module.exports = __webpack_public_path__ + "img/shouhui1.41f2d117.png";